import { extractKeywords } from "@multimediallc/cb-roomlist-prefetch"

export const getKeywordString = (searchString?: string) => {
    const [searchKeywords, keywordHashtags] = extractKeywords(searchString)
    const formattedHashtags = keywordHashtags.map((keyword) => `#${keyword}`)
    const keywordString = [...searchKeywords, ...formattedHashtags].join(" ")
    return keywordString
}
